module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_1.dc3a05a9.svg";